import React from "react";
import { useFormContext } from "react-hook-form";
import { formatString } from "utils";
import WildHorse from "assets/images/saddle_logo_icon.png";
import { TextArea } from "components/Inputs/TextArea";

const Step5ReviewSubmit = ({ methods, horseData }) => {
  const { watch } = useFormContext();
  const formData = watch();

  const formatValue = (value) => {
    if (!value) return "-";
    if (typeof value === "object") {
      if (value.label) return value.label;
      if (value.street || value.streetName) {
        const street = value.street || value.streetName || "";
        const city = value.city || "";
        const state = value.state || "";
        const zipCode = value.zipCode || "";
        const phone = value.phone ? `, Phone: ${value.phone}` : "";
        return `${street}, ${city}, ${state} ${zipCode}${phone}`;
      }
      return JSON.stringify(value);
    }
    return String(value);
  };

  const getLabel = (key) => {
    const labels = {
      saddleType: "Saddle Type",
      seatSize: "Seat Size",
      discipline: "Discipline",
      shippingDestination: "Shipping Destination",
      shippingAddress: "Shipping Address",
      manufacturerName: "Manufacturer",
    };
    return labels[key] || key;
  };

  const renderSpecificationRow = (key, value) => {
    if (!value || (typeof value === "object" && Object.keys(value).length === 0)) {
      return null;
    }
    return (
      <div key={key} className="flex flex-col sm:flex-row sm:justify-between py-1.5 sm:py-2 border-b border-gray-200 gap-0.5 sm:gap-2">
        <span className="font-medium font-montserrat text-gray-700 text-xs sm:text-sm">{getLabel(key)}:</span>
        <span className="text-gray-900 font-montserrat text-xs sm:text-sm sm:text-right">{formatValue(value)}</span>
      </div>
    );
  };

  return (
    <div className="w-full">
      <h3 className="text-base sm:text-lg lg:text-xl font-bold font-montserrat text-[#2b364b] mb-4 sm:mb-6 text-center">
        Review & Submit
      </h3>

      <div className="space-y-4 sm:space-y-6 max-w-2xl mx-auto">
        {/* Horse Info Summary */}
        <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
          <h4 className="font-semibold font-montserrat text-[#2b364b] mb-2 sm:mb-3 text-sm sm:text-base">Horse Information</h4>
          <div className="flex items-center gap-3 sm:gap-4">
            <img
              src={horseData?.photo?.trim() ? horseData.photo : WildHorse}
              alt={horseData?.name || "Horse"}
              className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 rounded-lg object-cover flex-shrink-0"
            />
            <div className="min-w-0">
              <p className="font-medium font-montserrat text-sm sm:text-base truncate">{horseData?.name || "Horse Name"}</p>
              <p className="text-xs sm:text-sm font-montserrat text-gray-600">
                Measurements will be automatically included
              </p>
            </div>
          </div>
        </div>

        {/* Saddle Specifications */}
        <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
          <h4 className="font-semibold font-montserrat text-[#2b364b] mb-2 sm:mb-3 text-sm sm:text-base">Saddle Specifications</h4>
          <div className="space-y-0.5 sm:space-y-1">
            {renderSpecificationRow("saddleType", formatString(formData.saddleType))}
            {renderSpecificationRow("seatSize", formatString(formData.seatSize))}
            {renderSpecificationRow("discipline", formatString(formData.discipline))}
          </div>
        </div>

        {/* Shipping Information */}
        <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
          <h4 className="font-semibold font-montserrat text-[#2b364b] mb-2 sm:mb-3 text-sm sm:text-base">Shipping Information</h4>
          <div className="space-y-0.5 sm:space-y-1">
            {renderSpecificationRow(
              "shippingDestination",
              formData.shippingDestination === "CUSTOMER"
                ? "Ship to Me"
                : formData.shippingDestination === "MANUFACTURER"
                  ? "Ship to Manufacturer"
                  : formData.shippingDestination
            )}
            {formData.shippingDestination === "CUSTOMER" &&
              renderSpecificationRow("shippingAddress", formData.shippingAddress)}
            {formData.shippingDestination === "MANUFACTURER" &&
              renderSpecificationRow("manufacturerName", formatString(formData.manufacturerName))}
          </div>
        </div>

        {/* Optional Notes */}
        <div>
          <TextArea
            name="notes"
            methods={methods}
            label="Additional Notes (Optional)"
            placeholder="Add any additional notes or special requests..."
            className="w-full"
            rows={4}
          />
        </div>
      </div>
    </div>
  );
};

export default Step5ReviewSubmit;
